var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welink-code-con"},[_c('div',{staticClass:"welink-qrcode"},[_c('div',{style:(_vm.styleObj),attrs:{"id":"qrcode"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }